WhatsRunningApp.Models.Feeds = Backbone.Model.extend({
    
    url: function() {
        return "/api/whats-running/feeds"
    },
    
    defaults: {
        feeds: ['initial state']
    },

    parse: function (data) {
        var model = {};
        model.feeds = data;
        return model;
    }
});